import { render, staticRenderFns } from "./Not404.vue?vue&type=template&id=78d8164d&scoped=true"
import script from "./Not404.vue?vue&type=script&lang=js"
export * from "./Not404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d8164d",
  null
  
)

export default component.exports